// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_tLCGhJ","filterContainer":"ob_dGHkGd","page":"ob_Fjvb2o","content":"ob_5r2cxx","skeletonLoaders":"ob_8t8QnI"};